import { css } from '@emotion/react';

export const sbbColors = css`
  --joy-palette-primary-solidBg: #eb0000;
  --joy-palette-primary-solidHoverBg: #d8000c;
  --joy-palette-primary-solidActiveBg: #c60018;
  --joy-palette-primary-solidDisabledBg: #ff8888;
`;
